import { useState } from 'react';
import { formatLocalDate } from '../utils/dateHelpers';

const useSecurityFilters = () => {
    const [securitySelectedSite, setSecuritySelectedSite] = useState('Select Site');
    const [securityDateFilters, setSecurityDateFilters] = useState({ shiftStart: '', shiftFinish: '' });
    const [securityFinancialWeek, setSecurityFinancialWeek] = useState({ description: 'Please Select' });
    const [securityCreateShiftVals, setSecurityCreateShiftVals] = useState({ venueid: '', codb: '', bun: '' });

    const handleSecuritySiteSelect = (siteName, venueID, codb, bun) => {
        setSecuritySelectedSite(siteName);
        setSecurityCreateShiftVals({ venueid: venueID, codb, bun });
    };

    const handleSecurityDateChange = (key, value) => {
        setSecurityDateFilters(prev => ({ ...prev, [key]: value }));
    };

    const handleSecurityFinancialWeekSelect = (financeWeek) => {
        setSecurityFinancialWeek(financeWeek);
        setSecurityDateFilters({
            shiftStart: formatLocalDate(financeWeek.weekCommencing),
            shiftFinish: formatLocalDate(financeWeek.weekEnding)
        });
    };

    return {
        securitySelectedSite,
        setSecuritySelectedSite,
        securityDateFilters,
        setSecurityDateFilters,
        securityFinancialWeek,
        setSecurityFinancialWeek,
        securityCreateShiftVals,
        setSecurityCreateShiftVals,
        handleSecuritySiteSelect,
        handleSecurityDateChange,
        handleSecurityFinancialWeekSelect,
    };
};

export default useSecurityFilters;
